export const mergeAfcStoreCodes = (
  storeCodes: string[] | undefined,
  afcStoreCodes: readonly string[] | undefined,
  isAfcStoreEnabled: boolean | undefined,
): string[] => {
  if (!isAfcStoreEnabled) return storeCodes ?? [];

  return Array.from(new Set([...(storeCodes ?? []), ...(afcStoreCodes ?? [])]));
};
